<template>
	<div class="full-page-error">
		<GenericErrorState
			@retry="$emit('retry', $event)"
			@back="goBack"
			showBack
		/>
	</div>
</template>

<script>
import { GenericErrorState } from '@/components/common'

export default {
	name: 'FullPageError',
	components: { GenericErrorState },
	methods: {
		goBack(e) {
			if (this.$attrs.onBack) {
				this.$emit('back', e)
			} else {
				this.$router.go(-1)
			}
		},
	},
	emits: ['retry', 'back'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.full-page-error {
	@include fixed-cover;
	@include flex-center;
	width: 100%;
	height: 100%;
}
</style>
